import { render } from "./TelegramUnlink.vue?vue&type=template&id=26ec53ae&ts=true"
import script from "./TelegramUnlink.vue?vue&type=script&lang=ts"
export * from "./TelegramUnlink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__